import { defineStore } from 'pinia'
import { store } from '@/store'
import { Storage } from '@/utils/Storage'
import { ACCESS_TOKEN_KEY, USER_INFO_KEY } from '@/enums/cacheEnum'
import { getUserInfo } from '@/api/user'
import dayjs from 'dayjs'
interface UserState {
  token: string
  userId: string
  userInfo: object
  seltab: number
  benefit: any[]
  popupRegisterPhone: boolean
  popupRegisterPhoneTimer: number
  isOpenPopupRegisterPhone: boolean
}

// 本地为 24小时
// 测试/正式环境为 10分钟
const ex = location.hostname === 'localhost' ? 24 * 60 * 60 : 10 * 60
const localUserInfo: any = Storage.get(USER_INFO_KEY) || {}

export const useUserStore = defineStore({
  id: 'user',
  state: (): UserState => ({
    token: Storage.getCookie(ACCESS_TOKEN_KEY) || '',
    userId: localUserInfo?.id || '',
    userInfo: localUserInfo || {},
    seltab: 1, //利润情况的tab记录
    benefit: [],
    popupRegisterPhone: false,
    popupRegisterPhoneTimer: 0,
    isOpenPopupRegisterPhone: Boolean(!localUserInfo?.phoneNumber),
  }),
  getters: {
    getToken: (state) => {
      return state.token as string
    },
  },
  actions: {
    // 重置登录信息
    resetOAuth() {
      this.token = ''
      this.userInfo = {}
      this.userId = ''
      Storage.removeCookie(ACCESS_TOKEN_KEY)
      Storage.remove(USER_INFO_KEY)
    },
    /** 清空token及用户信息 */
    resetToken() {
      this.token = ''
    },
    /** 登录成功保存token */
    setToken(token: string) {
      this.token = token ?? ''
      Storage.setCookie(ACCESS_TOKEN_KEY, this.token, ex)
    },
    async getUserInfo() {
      const resp = await getUserInfo({ token: this.token })
      const { data } = resp
      if (data?.memberDto) {
        const memberEndTime = new Date(
          data?.memberDto?.endTime?.replace(/-/g, '/')
        )
        const now = Date.now()
        const dayDate = 24 * 60 * 60 * 1e3 - 1e3
        let isValiddMember = true // 有效会员：未过期
        if (memberEndTime?.getTime() + dayDate < now) {
          isValiddMember = false
        }
        data.memberDto.isValiddMember = isValiddMember
      }
      this.isOpenPopupRegisterPhone = Boolean(!data.phoneNumber)
      this.delayPopupRegisterPhone()
      this.userId = data.id || ''
      Storage.set(USER_INFO_KEY, data)
      this.userInfo = data
      return resp
    },
    setGrowthLevelRights(benefit: any[]) {
      this.benefit = benefit
    },
    runPopupRegisterPhone() {
      this.isOpenPopupRegisterPhone = true
      this.openPopupRegisterPhone()
    },
    openPopupRegisterPhone() {
      this.popupRegisterPhone = true
      this.delayPopupRegisterPhone()
    },
    delayPopupRegisterPhone() {
      clearTimeout(this.popupRegisterPhoneTimer)
      if (this.isOpenPopupRegisterPhone && !this.popupRegisterPhone) {
        this.popupRegisterPhoneTimer = setTimeout(() => {
          this.popupRegisterPhone = true
        }, 5e3)
      }
    },
    closePopupRegisterPhone(isStop?: boolean) {
      clearTimeout(this.popupRegisterPhoneTimer)
      this.popupRegisterPhone = false
      if (!isStop) this.delayPopupRegisterPhone()
      else this.isOpenPopupRegisterPhone = false
    },
  },
})

// 在组件setup函数外使用
export function useUserStoreWithOut() {
  return useUserStore(store)
}
